import { Directive, afterNextRender } from '@angular/core';

import { appInjectElement } from '@shared/utils/inject-element';

@Directive({
  selector: '[appTransitioned]',
  host: {
    style: 'transition: none',
  },
})
export class Transitioned {
  constructor() {
    const el = appInjectElement();

    afterNextRender(() => requestAnimationFrame(() => el.style.setProperty('transition', '')));
  }
}
